<script setup lang="ts">
import { useSnackStore } from "@/stores/snack";
import { nextTick, ref, watch } from "vue";

const snackStore = useSnackStore();
const attachTarget = ref<string | boolean | Element | undefined>(undefined);

watch(
  () => snackStore.show,
  show => {
    if (show) {
      nextTick(() => {
        const anchorInDialog = document.querySelectorAll(".v-overlay--active .globalSnackbarAnchor");
        if (anchorInDialog.length > 0) {
          attachTarget.value = anchorInDialog[anchorInDialog.length - 1];
          return;
        }

        const anchorDefault = document.querySelector(".globalSnackbarAnchor");
        attachTarget.value = anchorDefault ?? "body";
      });
    }
  },
  { immediate: true }
);
</script>

<template>
  <v-snackbar
    v-model="snackStore.show"
    :timeout="snackStore.snack.timeout"
    :color="snackStore.snack.color"
    location="top"
    class="globalSnackbar"
    :attach="attachTarget"
  >
    <div v-html="snackStore.snack.message"></div>
    <template #actions>
      <v-btn
        color="white"
        @click="snackStore.show = false"
      >
        <v-icon icon="mdi-close" />
      </v-btn>
    </template>
  </v-snackbar>
</template>

<style lang="scss" scoped>
.globalSnackbar {
  margin: 0;
  z-index: 2413;

  :deep(.v-snackbar__wrapper) {
    width: 100%;
    max-width: none;
    border-radius: 0;
    top: 56px;
    left: 0;
    right: 0;

    .v-snackbar__content {
      min-height: 56px;
      text-align: center;
      font-size: 1rem;
      line-height: 1.25;
      padding: 18px 16px;
    }
  }
}
</style>
